<template lang="pug">
.Home
  Slider.slC(:videoUrl="sliderVideo" :slideData="slideData")
  SliderM.slM(:videoUrl="sliderVideo" :slideData="slideData")
  HomeLink(v-bind="mainData").hlC
  HomeLinkM(v-bind="mainData").hlM
  homeanimate
  aniplane
  .cat

</template>

<script>
import { GetSlidersByGroupID } from '@/api/client/Slider';
import { fetchPortalBlockData } from '@/api/client/Project';
import Slider from '@/components/Slider'
import HomeLink from '@/components/HomeLink'
import SliderM from '@/components/SliderM'
import HomeLinkM from '@/components/HomeLinkM'
import homeanimate from '@/components/homeanimate'
import aniplane from '@/components/aniplane'
export default {
  components: { Slider, HomeLink, SliderM, HomeLinkM, homeanimate, aniplane },
  data() {
    return {
      slideData: [],
      sliderVideo: '',
      mainData: {
        link: null,
        video: null,
        tabData: [],
        specialArticles: []
      },
    }
  },
  async created() {
    await Promise.all([
      this.handelPortalBlockData(),
      this.handelSlideData()
    ])
  },
  methods: {
    async handelPortalBlockData() {
      const { data } = await fetchPortalBlockData()
      const { link, video1, video2, special_articles, bulletin, activity_results, activity_news } = data
      this.sliderVideo = video1
      this.mainData = {
        link,
        video: video2,
        tabData: [
          {
            id: 1,
            text: '最新消息',
            data: bulletin
          },
          // {
          //   id: 2,
          //   text: '最新活動',
          //   data: activity_results
          // },
          // {
          //   id: 3,
          //   text: '最新影音',
          //   data: activity_news
          // }
        ],
        specialArticles: special_articles
      }
    },
    async handelSlideData() {
      const { data } = await GetSlidersByGroupID(1, 0)
      this.slideData = data
    },
  }

}
</script>

<style lang="sass">
@import '@/assets/style.sass'

.Home
  width: 100%
  box-sizing: border-box
  +flexcolumn
  align-items: center
  // padding: 0 0 350px 0
  +phone
    // padding: 0 0 550px 0

  .slC
    +pad
      display: none
  .slM
    display: none
    +pad
      display: flex
  .hlC
    +pad
      display: none
  .hlM
    display: none
    +pad
      display: flex
  .cat
    position: absolute
    width: 30%
    height: 7vw
    background: url('../../assets/cat.png')
    +bgcon
    background-position: 0 0
    margin-top: 78.5vw
    margin-left: -27vw
    +pad
      // width: 50%
      // +bb
      margin-top: 250vw
      height: 15vw
      margin-left: -10vw
      +ie
        display: none
    +phone
      margin-top: 473vw
      height: 30vw
      margin-left: -24vw
    +ie
      margin-top: -49.4vw
      margin-left: -36vw
      display: none


</style>



// WEBPACK FOOTER //
// src/views/Home/Home.vue